import { AfterViewInit, Component } from '@angular/core';
import { DevicesService } from '../../../services/devices.service';
import { LoginUserModel } from '../../../models/loginUserModel';
import { jwtDecode } from 'jwt-decode';
import { CustomTableComponent } from "../../../utils/custom-table/custom-table.component";
import { LoaderComponent } from "../../../utils/loader/loader.component";
import { DatepickerComponent } from "../../../utils/datepicker/datepicker.component";
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';

@Component({
    selector: 'app-requests',
    imports: [CustomTableComponent, LoaderComponent, DatepickerComponent, CommonModule, ButtonModule ],
    templateUrl: './requests.component.html',
    styleUrl: './requests.component.scss'
})
export class RequestsComponent implements AfterViewInit {

  data!: LoginUserModel;
  searching: boolean = true;
  tokenAuth = "";
  allRequests: any[] = [];
  uniqueRequest: any[] = [];
  cardsOnRequest: any[] = [];
  detailRequest = false;
  isFirstSearch=true;
  tableButtons = [{
    text: 'Detalle',
    action: (event: any) => this.showCards(event),
    icon: undefined,
    color: '',
    hasIcon: true,
    showText:false,
  }
  ];
  today = new Date();
  headersSolicitudes: any[] = [{ key: "proc_inst_id", textHeader: "# ID", visible: true }, { key: "userName", textHeader: "Solicitante", visible: true }, { key: "creationDate", textHeader: "Fecha", visible: true,type:"date" }, { key: "dueDate", textHeader: "Vencimiento", visible: true,type:"date" }, { key: "status", textHeader: "Status", visible: true }]
  headerCards: any[] = [{ key: "user", textHeader: "Usuario", visible: true }, { key: "vehicle", textHeader: "Vehículo", visible: true }, { key: "ecoNumber", textHeader: "No. Económico", visible: true }, { key: "department", textHeader: "Departamento", visible: true }, { key: "weeklyLimitLiters", textHeader: "Consumo Máx . Semanal", visible: true }, { key: "fuelType", textHeader: "Tipo de Combustible", visible: true }]
  fromDate: Date = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 4, 0, 0, 0);
  toDate: Date = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 7, 0, 0, 0);
  requestFrom:any;

  requestTo:any;
  constructor(private service: DevicesService, private titleService:Title, private themeService:ThemeService
      
    ) {
      this.titleService.setTitle("Seguimiento - Solciitud Dispositivos");
      this.themeService.setTitle("Seguimiento Solicitud de Dispositivos");

    this.data = JSON.parse(localStorage.getItem('data')!); 
  }
  ngOnInit() {
   
  }

  ngAfterViewInit() {
    this.obtenerSolicitudes();
  }

  toogleOptions(){
    
  }

  obtenerSolicitudes() {
    this.searching = true;
    this.requestFrom = new Date(this.fromDate);
    this.requestTo = new Date(this.toDate);
 
    this.uniqueRequest=[];
    this.service.getRequests(this.data.Client_number, this.requestFrom, this.requestTo).subscribe({
      next: (resp: any) => {
        this.allRequests = resp;
        var filterRequest = resp.filter(
          (obj: any, index: any) =>
            resp.findIndex((item: any) => item.proc_inst_id === obj.proc_inst_id) === index
        );


        filterRequest.forEach((element: any) => {
          var creationDate: Date = new Date(element.creationDate);
          var newRequest = {
            id: element.id,
            proc_inst_id: element.proc_inst_id,
            userName: element.userName,
            creationDate: creationDate,
            dueDate: this.vigenciaSolicitud(element.creationDate, 5),
            status: this.getStatusRequest(element.status),
          }
          this.uniqueRequest.push(newRequest);
        });
        this.searching = false;
      },
      error:(err:any)=>{
        this.allRequests = [];
        this.searching = false;

      }
    })
  }
  getStatusRequest(status: number) {
    switch (status) {
      case 1:
        return "Pendiente";

      case 2:

        return "En Proceso";

      case 3:

        return "En Proceso";


      case 4:

        return "Entregado";


      case 5:

        return "Cancelado";


      case 6:

        return "En Reparto";


      case 7:

        return "Listo para Recolección";

      default:
        return "En Proceso";

    }
  }

  vigenciaSolicitud(inicio: Date, dias: number) {
    var fechaInicio = new Date(inicio);
    if (isNaN(dias)) {
      return
    }

    if (!(fechaInicio instanceof Date)) {
     
      return
    }

    var diaSemana = fechaInicio.getDay();
    var cantDias = dias;
    if (diaSemana == 0) {
      cantDias++;
    }


    if (diaSemana + cantDias >= 6) {

      var diasLaborales = cantDias - (5 - diaSemana);

      cantDias += 2;
      if (diasLaborales > 5) {

        cantDias += 2 * Math.floor(diasLaborales / 5);

        if (diasLaborales % 5 == 0)
          cantDias -= 2;
      }
    }

    fechaInicio.setDate(fechaInicio.getDate() + cantDias);

    var newDateVigencia = new Date(fechaInicio);



    return newDateVigencia;
  }

  showCards(event: any) {
    let filtered = this.allRequests.filter((r: any) => r.proc_inst_id == event.proc_inst_id);

    let onlyCards: any[] = [];
    filtered.forEach(element => {
      let card:any={
        user:element.user,
        vehicle:element.vehicle,
        ecoNumber:element.ecoNumber,
        department:element.department,
        weeklyLimitLiters: element.weeklyLimitLiters + " Lts",
        fuelType : this.getMasiveSelectedProductsText(element.fuelType),

      } 

      
      onlyCards.push(card);
    });
   
    this.cardsOnRequest = onlyCards;
    this.detailRequest = true;
  }


  getMasiveSelectedProductsText(productCode: string) {
    let products = "";
    if (this.tieneProductoText(1, productCode)) {
      products += "Regular";
    }
    if (this.tieneProductoText(2, productCode)) {
      products += products.trim() == '' ? "Supreme" : " - Supreme";
    }
    if (this.tieneProductoText(3, productCode)) {
      products += products.trim() == '' ? "Diesel" : " - Diesel";
    }

    return products;
  }

  tieneProductoText(product: number, productCode: string) {
    return productCode.includes(product.toString());

  }
  setDatesOnFilter(dates:any){
    this.isFirstSearch=false;
    this.fromDate=dates.from;
    this.toDate=dates.to;
  }
}
